module.exports = __webpack_public_path__ + "img/邵长青.1648052d.png";